import { MainLayout } from 'shared/ui/layout/main';

import { GroupTabs } from '../tabs';

export function ChargePointGroupLayout() {
  return <MainLayout tabs={<GroupTabs />} />;
}
